// import { AuthorizedRequestArg } from '../signin/auth';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store';

const refreshTokenTimeout = 3600 * 1000;

export type AuthStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

interface AuthState {
  status: AuthStatus;
  error: string | null;
  token: GoogleToken | null;
  refreshTimeout: number | null;
}

export interface CodeArg {
  code: string;
}

export interface OAuthToken {
  access_token: string;
  token_type: string | null;
  refresh_token: string | null;
  expiry: string | null;
}

export interface GoogleToken {
  token: OAuthToken;
  id_token: string;
}

export interface WamAuthResponse {
  token: GoogleToken;
  signedIn: boolean;
}

export const refreshToken = createAsyncThunk('auth/refresh', async (_, {dispatch}) => {
  console.log('Refreshing token...');
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_ROOT}/WamAuth`,
    {
      credentials: 'include',
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
      }),
      body: JSON.stringify({
        'refreshToken': true,
      }),
    })
    .then(res => res.json().then(json => json.data as WamAuthResponse));
  dispatch(setAccessToken(response));
  dispatch(setRefreshTimeout(window.setTimeout(() => {
    console.log('Dispatching token refresh...');
    dispatch(refreshToken());
  }, refreshTokenTimeout)));
});

export const signOut = createAsyncThunk('auth/signOut', async (_, {dispatch}) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_ROOT}/WamAuth`,
    {
      credentials: 'include',
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
      }),
      body: JSON.stringify({
        'signOut': true,
      }),
    })
    .then(res => res.json().then(json => json.data as WamAuthResponse));
  dispatch(setAccessToken(response));
  dispatch(setRefreshTimeout(window.setTimeout(() => {
    console.log('Dispatching token refresh...');
    dispatch(refreshToken());
  }, refreshTokenTimeout)));
});

function loadToken(): GoogleToken | null {
  // const tokenString = localStorage.getItem('token');
  // if (tokenString) {
  //  return JSON.parse(tokenString);
  // }
  return null;
}

function storeToken(token: GoogleToken) {
  // localStorage.setItem('token', JSON.stringify(token));
}

function clearToken() {
  // localStorage.removeItem('token');
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    status: 'idle',
    error: null,
    token: loadToken(),
    refreshTimeout: null,
  } as AuthState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<WamAuthResponse>) => {
      state.token = action.payload.token;
      storeToken(state.token);
    },
    setRefreshTimeout: (state, action: PayloadAction<number>) => {
      if (state.refreshTimeout) {
        window.clearTimeout(state.refreshTimeout);
      }
      state.refreshTimeout = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(refreshToken.pending, (state, _) => {
      state.status = 'loading';
    });
    builder.addCase(refreshToken.fulfilled, (state, action) => {
      state.status = 'succeeded';
      console.log('Success', action.payload);
    });
    builder.addCase(refreshToken.rejected, (state, action) => {
      state.status = 'failed';
      console.log('Error', action.error.message)
      state.error = action.error.message || null;
    });

    builder.addCase(signOut.pending, (state, _) => {
      state.token = null;
      clearToken();
      if (state.refreshTimeout) {
        window.clearTimeout(state.refreshTimeout);
        state.refreshTimeout = null;
      }
    });
    builder.addCase(signOut.fulfilled, (state, action) => {
      state.status = 'succeeded';
      console.log('Success', action.payload);
    });
    builder.addCase(signOut.rejected, (state, action) => {
      state.status = 'failed';
      console.log('Error', action.error.message)
      state.error = action.error.message || null;
    });
  }
});

export const { setAccessToken, setRefreshTimeout } = authSlice.actions;

export const selectAccessToken = (state: RootState): string | null => state.auth.token?.id_token || null;
export const selectAuthStatus = (state: RootState): AuthStatus => state.auth.status || null;

export default authSlice.reducer;